// JavaScript Document
//components/signs/option/View.js
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
//import Button from '@material-ui/core/Button';
//import Zoom from '@material-ui/core/Zoom';
//import { makeStyles } from '@material-ui/core/styles';
/*
const useStyles = makeStyles({
  table: {
    minWidth: 650,
	maxHeight:'calc(100vh - 64px)',
	//maxHeight: '100%'
  },
});
*/

export default function View(props) {
  //const classes = useStyles();
	const {path, name} = props;
	//const [path, setPath] = React.useState()
  //const [loaded, setLoaded] = React.useState(false);
  //const [signsList, setSignsList] = React.useState([]);
	/*
  React.useEffect(() => {
		if(!loaded){
			getSignsList();
		}
	});
  const getSignsList = () =>{
	  setLoaded(true);
	  handleSend({
		  vso: 'signslist'
	  }, (data) => {
		  setSignsList(data.signs);
	  });
  }
  /*
  'background-image' : 'url('+img+')',
			'background-size' : 'contain',
			'background-repeat' : 'no-repeat',
			'background-position' : 'center',
			*/
	//const renderBase = () => {
	return (
		<Tooltip title={name} arrow>
			<div style={{
				backgroundImage:'url("http://forteltraffic.com/'+encodeURI(path)+'")', 
	  			backgroundSize:'contain', 
	  			backgroundRepeat:'no-repeat', 
	  			backgroundPosition:'center',
				minWidth:50,
				minHeight:50,
	  		}}>
				{path ? '' : name}
	  		</div>
		</Tooltip>
	);
	//}
	/*
	const render = () => {
		if(onClick)
			return (<Button onClick={onClick}>{renderBase()}</Button>);
		return renderBase();
	}
	return render();
	*/
}
